import { useGetPlatformTermsPendingQuery } from '../components/Onboarding/services/onboardingApi';
export function usePlatformTermsSourceUrl() {
    const { data, isLoading, isFetching } = useGetPlatformTermsPendingQuery();
    const term = data?.result?.term;
    const termsSourceUri = term?.sourceType === 'LINK' && term.sourceValue?.trim() ? term.sourceValue : undefined;
    return {
        termsSourceUri,
        isLoading: isLoading || isFetching,
    };
}
